// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { motion, AnimatePresence } from 'framer-motion';
// import { 
//   MdVerified, MdSearch, MdStore, MdInventory, MdShoppingBag 
// } from 'react-icons/md';
// import { 
//   FiShoppingCart, FiHeart, FiPlus, FiMinus, FiArrowLeft, FiFilter 
// } from 'react-icons/fi';

// const VendorShop = () => {
//   const { vendorName } = useParams();
//   const navigate = useNavigate();
  
//   const [vendor, setVendor] = useState(null);
//   const [products, setProducts] = useState([]);
//   const [filteredProducts, setFilteredProducts] = useState([]);
//   const [selectedCategory, setSelectedCategory] = useState("All");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [cart, setCart] = useState({});
//   const [categories, setCategories] = useState(["All"]);

//   useEffect(() => {
//     const fetchVendorData = async () => {
//       try {
//         setLoading(true);
//         const response = await fetch('https://server.havbit.in/api/public/products');
//         const data = await response.json();
        
//         if (data.success) {
//           const vendorProducts = data.data.filter(p => p.restaurantName === vendorName);
//           if (vendorProducts.length > 0) {
//             setVendor({ name: vendorProducts[0].restaurantName, count: vendorProducts.length });
//             setProducts(vendorProducts);
//             setCategories(["All", ...new Set(vendorProducts.map(p => p.category).filter(Boolean))]);
//           } else { navigate("/"); }
//         }
//       } catch (error) { console.error(error); } finally { setLoading(false); }
//     };
//     fetchVendorData();
//   }, [vendorName, navigate]);

//   useEffect(() => {
//     let result = products.filter(p => {
//       const matchesCat = selectedCategory === "All" || p.category === selectedCategory;
//       const matchesSearch = p.name.toLowerCase().includes(searchQuery.toLowerCase());
//       return matchesCat && matchesSearch;
//     });
//     setFilteredProducts(result);
//   }, [products, selectedCategory, searchQuery]);

//   if (loading) return (
//     <div className="min-h-screen flex items-center justify-center bg-white">
//       <motion.div animate={{ rotate: 360 }} transition={{ repeat: Infinity, duration: 1 }} className="w-12 h-12 border-4 border-black border-t-transparent rounded-full" />
//     </div>
//   );

//   return (
//     <div className="min-h-screen bg-[#fafafa] text-[#1a1a1a] font-sans">
      
//       {/* 1. STICKY MINIMAL HEADER */}
//       <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100">
//         <div className="max-w-screen-2xl mx-auto px-6 h-16 flex items-center justify-between">
//           <button onClick={() => navigate(-1)} className="flex items-center gap-2 font-medium hover:text-red-600 transition-colors">
//             <FiArrowLeft size={20}/> <span>Back</span>
//           </button>
//           <div className="flex items-center gap-2">
//             <MdStore size={22} className="text-red-600"/>
//             <span className="font-bold tracking-tight text-lg uppercase">{vendor?.name}</span>
//           </div>
//           <div className="relative">
//             <MdShoppingBag size={24}/>
//             {Object.keys(cart).length > 0 && (
//               <span className="absolute -top-1 -right-1 bg-red-600 text-white text-[10px] w-4 h-4 rounded-full flex items-center justify-center font-bold">
//                 {Object.values(cart).reduce((a, b) => a + b, 0)}
//               </span>
//             )}
//           </div>
//         </div>
//       </header>

//       {/* 2. HERO / BRAND SECTION */}
//       <section className="bg-white px-6 py-12 border-b border-gray-100">
//         <div className="max-w-4xl mx-auto text-center">
//           <motion.div 
//             initial={{ opacity: 0, scale: 0.9 }} 
//             animate={{ opacity: 1, scale: 1 }}
//             className="w-24 h-24 bg-black text-white rounded-full flex items-center justify-center text-4xl font-bold mx-auto mb-6 shadow-2xl"
//           >
//             {vendor?.name?.charAt(0)}
//           </motion.div>
//           <h1 className="text-4xl md:text-5xl font-black mb-2 flex items-center justify-center gap-3">
//             {vendor?.name} <MdVerified className="text-blue-500" size={30}/>
//           </h1>
//           <p className="text-gray-500 font-medium tracking-wide italic">Official Brand Store • {vendor?.count} Curated Products</p>
//         </div>
//       </section>

//       {/* 3. SEARCH & CATEGORY BAR */}
//       <div className="sticky top-[65px] z-40 bg-white border-b border-gray-100 px-6 py-4">
//         <div className="max-w-screen-2xl mx-auto flex flex-col md:flex-row gap-4 items-center">
//           <div className="relative flex-1 w-full">
//             <MdSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" size={20} />
//             <input 
//               type="text" 
//               placeholder="Search in store..." 
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//               className="w-full pl-12 pr-4 py-3 bg-gray-50 rounded-full border-none focus:ring-2 focus:ring-black transition-all"
//             />
//           </div>
//           <div className="flex gap-2 overflow-x-auto w-full md:w-auto no-scrollbar pb-1">
//             {categories.map(cat => (
//               <button
//                 key={cat}
//                 onClick={() => setSelectedCategory(cat)}
//                 className={`px-6 py-2 rounded-full text-sm font-bold whitespace-nowrap transition-all ${
//                   selectedCategory === cat ? "bg-black text-white shadow-lg" : "bg-gray-100 text-gray-600 hover:bg-gray-200"
//                 }`}
//               >
//                 {cat}
//               </button>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* 4. PRODUCT GRID */}
//       <main className="max-w-screen-2xl mx-auto px-6 py-10">
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-10">
//           <AnimatePresence>
//             {filteredProducts.map((product) => (
//               <motion.div
//                 key={product._id}
//                 layout
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 className="group relative flex flex-col"
//               >
//                 {/* Image Container */}
//                 <div className="relative aspect-[3/4] rounded-[32px] overflow-hidden bg-white shadow-sm border border-gray-100 transition-all duration-500 group-hover:shadow-2xl group-hover:-translate-y-2">
//                   <img 
//                     src={product.image} 
//                     alt={product.name} 
//                     className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
//                   />
                  
//                   {/* Floating Badge */}
//                   {product.oldPrice > product.newPrice && (
//                     <div className="absolute top-5 left-5 bg-white/90 backdrop-blur-sm text-black text-[10px] font-black px-3 py-1 rounded-full uppercase">
//                       -{Math.round(((product.oldPrice - product.newPrice)/product.oldPrice)*100)}% OFF
//                     </div>
//                   )}

//                   {/* Glass Add Button (Overlay) */}
//                   <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
//                     {!cart[product._id] ? (
//                       <button 
//                         onClick={() => setCart({...cart, [product._id]: 1})}
//                         className="bg-white text-black font-bold px-8 py-3 rounded-full flex items-center gap-2 hover:scale-105 transition-transform"
//                       >
//                         <FiShoppingCart /> QUICK ADD
//                       </button>
//                     ) : (
//                       <div className="bg-white rounded-full p-2 flex items-center gap-4 shadow-xl">
//                         <button onClick={() => setCart({...cart, [product._id]: cart[product._id] - 1})} className="w-10 h-10 rounded-full hover:bg-gray-100 flex items-center justify-center"><FiMinus/></button>
//                         <span className="font-black text-lg">{cart[product._id]}</span>
//                         <button onClick={() => setCart({...cart, [product._id]: cart[product._id] + 1})} className="w-10 h-10 rounded-full hover:bg-gray-100 flex items-center justify-center"><FiPlus/></button>
//                       </div>
//                     )}
//                   </div>
//                 </div>

//                 {/* Info Container */}
//                 <div className="mt-6 px-2">
//                   <h3 className="text-lg font-bold text-gray-900 group-hover:text-red-600 transition-colors truncate">
//                     {product.name}
//                   </h3>
//                   <div className="flex items-center gap-3 mt-1">
//                     <span className="text-xl font-black">₹{product.newPrice}</span>
//                     {product.oldPrice > product.newPrice && (
//                       <span className="text-sm text-gray-400 line-through font-medium">₹{product.oldPrice}</span>
//                     )}
//                   </div>
//                 </div>
//               </motion.div>
//             ))}
//           </AnimatePresence>
//         </div>

//         {filteredProducts.length === 0 && (
//           <div className="text-center py-40">
//             <h2 className="text-2xl font-black text-gray-300 uppercase tracking-widest italic">Store is Empty</h2>
//             <p className="text-gray-400 mt-2">Try searching for something else.</p>
//           </div>
//         )}
//       </main>

//       {/* 5. FLOATING MOBILE CART SUMMARY */}
//       {Object.keys(cart).length > 0 && (
//         <motion.div 
//           initial={{ y: 100 }} 
//           animate={{ y: 0 }} 
//           className="fixed bottom-8 left-1/2 -translate-x-1/2 z-50 bg-black text-white px-8 py-4 rounded-full shadow-2xl flex items-center gap-6"
//         >
//           <div className="flex flex-col border-r border-white/20 pr-6">
//             <span className="text-[10px] text-gray-400 uppercase font-bold tracking-widest">Bag Total</span>
//             <span className="text-lg font-black">₹{Object.keys(cart).reduce((sum, id) => {
//               const p = products.find(prod => prod._id === id);
//               return sum + (p?.newPrice * cart[id]);
//             }, 0)}</span>
//           </div>
//           <button className="font-black text-sm uppercase tracking-tighter flex items-center gap-2 hover:text-red-500 transition-colors">
//             Checkout Now <FiArrowLeft className="rotate-180" />
//           </button>
//         </motion.div>
//       )}
//     </div>
//   );
// };

// export default VendorShop;






import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import {
  MdVerified,
  MdSearch,
  MdStore,
  MdShoppingBag,
} from "react-icons/md";
import {
  FiShoppingCart,
  FiPlus,
  FiMinus,
  FiArrowLeft,
} from "react-icons/fi";

const VendorShop = () => {
  const { vendorName } = useParams();
  const navigate = useNavigate();

  const [vendor, setVendor] = useState(null);
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [cart, setCart] = useState({});
  const [categories, setCategories] = useState(["All"]);

  const token = localStorage.getItem("vendorToken");

  /* ================= FETCH DATA ================= */
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        let brandNameFromAPI = vendorName; // fallback

        /* ---------- 1. GET BRAND ---------- */
        if (token) {
          try {
            const brandRes = await fetch(
              "https://server.havbit.in/api/vendor/brand",
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );

            const brandData = await brandRes.json();

            if (brandData?.data?.brandName) {
              brandNameFromAPI = brandData.data.brandName;
            }
          } catch (err) {
            console.log("Brand fetch failed, using URL param");
          }
        }

        /* ---------- 2. GET PRODUCTS ---------- */
        const productRes = await fetch(
          "https://server.havbit.in/api/public/products"
        );
        const productData = await productRes.json();

        if (productData.success) {
          const vendorProducts = productData.data.filter(
            (p) =>
              p.restaurantName?.toLowerCase() ===
              brandNameFromAPI.toLowerCase()
          );

          if (vendorProducts.length > 0) {
            setVendor({
              name: brandNameFromAPI,
              count: vendorProducts.length,
            });

            setProducts(vendorProducts);

            setCategories([
              "All",
              ...new Set(
                vendorProducts.map((p) => p.category).filter(Boolean)
              ),
            ]);
          } else {
            navigate("/");
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [vendorName, token, navigate]);

  /* ================= FILTER ================= */
  useEffect(() => {
    let result = products.filter((p) => {
      const matchesCat =
        selectedCategory === "All" || p.category === selectedCategory;
      const matchesSearch = p.name
        .toLowerCase()
        .includes(searchQuery.toLowerCase());

      return matchesCat && matchesSearch;
    });

    setFilteredProducts(result);
  }, [products, selectedCategory, searchQuery]);

  /* ================= LOADER ================= */
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 1 }}
          className="w-12 h-12 border-4 border-black border-t-transparent rounded-full"
        />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#fafafa] text-[#1a1a1a]">

      {/* HEADER */}
      <header className="sticky top-0 bg-white border-b px-6 h-16 flex items-center justify-between">
        <button onClick={() => navigate(-1)} className="flex items-center gap-2">
          <FiArrowLeft /> Back
        </button>

        <div className="flex items-center gap-2">
          <MdStore className="text-red-600" />
          <span className="font-bold uppercase">{vendor?.name}</span>
        </div>

        <div className="relative">
          <MdShoppingBag size={24} />
          {Object.keys(cart).length > 0 && (
            <span className="absolute -top-1 -right-1 bg-red-600 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center">
              {Object.values(cart).reduce((a, b) => a + b, 0)}
            </span>
          )}
        </div>
      </header>

      {/* HERO */}
      <section className="bg-white py-10 text-center">
        <div className="w-20 h-20 bg-black text-white rounded-full flex items-center justify-center text-3xl mx-auto mb-4">
          {vendor?.name?.charAt(0)}
        </div>

        <h1 className="text-3xl font-bold flex items-center justify-center gap-2">
          {vendor?.name} <MdVerified className="text-blue-500" />
        </h1>

        <p className="text-gray-500">
          {vendor?.count} Products Available
        </p>
      </section>

      {/* SEARCH */}
      <div className="px-6 py-4 bg-white border-b">
        <input
          type="text"
          placeholder="Search..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="w-full p-3 rounded-full bg-gray-100"
        />
      </div>

      {/* PRODUCTS */}
      <main className="p-6 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {filteredProducts.map((product) => (
          <div key={product._id} className="bg-white p-3 rounded-xl shadow">

            <img
              src={product.image}
              alt={product.name}
              className="h-40 w-full object-cover rounded-lg"
            />

            <h3 className="font-bold mt-2">{product.name}</h3>

            <p className="font-semibold">₹{product.newPrice}</p>

            {!cart[product._id] ? (
              <button
                onClick={() =>
                  setCart({ ...cart, [product._id]: 1 })
                }
                className="mt-2 bg-black text-white px-3 py-1 rounded"
              >
                Add
              </button>
            ) : (
              <div className="flex items-center gap-2 mt-2">
                <button
                  onClick={() =>
                    setCart({
                      ...cart,
                      [product._id]: cart[product._id] - 1,
                    })
                  }
                >
                  <FiMinus />
                </button>

                <span>{cart[product._id]}</span>

                <button
                  onClick={() =>
                    setCart({
                      ...cart,
                      [product._id]: cart[product._id] + 1,
                    })
                  }
                >
                  <FiPlus />
                </button>
              </div>
            )}
          </div>
        ))}
      </main>
    </div>
  );
};

export default VendorShop;